// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_ca2961cd","size1":"rdg_cd43d37f","size2":"rdg_0433ce17","size3":"rdg_ac8110bd","size4":"rdg_502749fa","size5":"rdg_805ef4ca","size6":"rdg_4e95135f"};